<div class="df-skeleton-table" aria-hidden="true">
  @if (showToolbar) {
    <div class="df-skeleton-table-toolbar">
      <div class="df-skeleton-table-toolbar-item"></div>
      <div class="df-skeleton-table-toolbar-item"></div>
      <div class="df-skeleton-table-toolbar-item"></div>
    </div>
  }
  <div class="df-skeleton-table-row df-skeleton-table-row--header"></div>
  @for (row of rowPlaceholders; track row) {
    <div class="df-skeleton-table-row"></div>
  }
</div>
